import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { WidgetHeaderView } from "./Widget/WidgetFrame";
import { useInitialSettings } from "../context/settings";
import { WidgetBackButton } from "./Widget/WidgetNavigationView";
import LogoWithDetails from "./Common/LogoWithDetails";
import { WalletsHeader } from "./Wallet/WalletComponents/ConnectedWallets";
import LayerswapMenu from "./Menu";
import AppSettings from "../lib/AppSettings";
import LayerSwapApiClient from "../lib/apiClients/layerSwapApiClient";
function HeaderWithMenu({ goBack, contextualMenu }) {
    const initialSettings = useInitialSettings();
    const isHeaderLogoVisible = LayerSwapApiClient.apiKey !== AppSettings.LayerswapApiKeys['mainnet'] &&
        LayerSwapApiClient.apiKey !== AppSettings.LayerswapApiKeys['testnet'];
    const headerConfigs = AppSettings.ThemeData?.header;
    return (_jsx(WidgetHeaderView, { start: _jsx(_Fragment, { children: goBack ?
                _jsx(WidgetBackButton, { onClick: goBack })
                :
                    headerConfigs?.hideTabs ? null :
                        AppSettings.ThemeData?.enableWideVersion == true ?
                            (!initialSettings.hideLogo && isHeaderLogoVisible) ?
                                _jsx(LogoWithDetails, { className: "md:hidden" })
                                : null
                            : _jsx(_Fragment, { children: contextualMenu }) }), end: _jsxs(_Fragment, { children: [headerConfigs?.hideWallets ? null : _jsx(WalletsHeader, {}), AppSettings.ThemeData?.enableWideVersion == true ? contextualMenu : null, headerConfigs?.hideMenu ? null : _jsx(LayerswapMenu, {})] }) }));
}
export default HeaderWithMenu;
